<template>
    <div class="text-center">
        <div @click="$router.push({ name: 'missions' })"
             class="text-sm border border-blue-600 inline-block bg-white text-blue-600 font-bold px-8 cursor-pointer">
            {{ $t('component.applications.apply')}}
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ApplyButton'
    }
</script>